import React from 'react';
import { useSelector } from "react-redux";

export default () => {
    const user = useSelector(state => state.user);
    return <h2 style={{margin: '40px auto',}}>Здравствуйте, {user.fullname}!</h2>
}